import React, { useState, useContext } from 'react';
import { AuthContext } from './AuthContext';
import { useUser } from './../context/UserContext';
import { useNavigate } from 'react-router-dom';
import './AuthPage.scss';
import googleIcon from './../assets/google-icon.svg';
import appleIcon from './../assets/apple-icon.svg';

const AuthPage: React.FC<{ onSuccess: () => void }> = ({ onSuccess }) => {
  const { signIn, signInWithGoogle, signInWithApple } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { setUserid } = useUser();
  const navigate = useNavigate();

  const handleSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) {
      setError('Please enter both email and password.');
      return;
    }

    try {
      const user = await signIn(email, password);
      onSuccess();
    } catch (err) {
      setError('Failed to sign in. Please check your credentials.');
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      await signInWithGoogle();
      navigate('/');
    } catch (err) {
      setError('Failed to sign in with Google.');
    }
  };

  const handleAppleSignIn = async () => {
    try {
      await signInWithApple();
      navigate('/');
    } catch (err) {
      setError('Failed to sign in with Apple.');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">

        {error && <p className="error-critical">{error}</p>}
        <form onSubmit={handleSignIn} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>
          <button type="submit" className="cta-button">
            Sign In
          </button>
        </form>
       
       
        <div className="additional-links">
          <a href="/forgot-password">Forgot Password?</a> &nbsp;&nbsp;
          <a href="/signup">Create an account</a>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;